<template>
  <div>
    <div class="container container--project-book">
      <div class="pageIntro pageIntro--project">
        <div v-if="!editing">
          <h1 class="headingOne pageIntro__heading">{{ projectName }}</h1>
          <a class="project-title__button" href="#!" @click.prevent="enableEditing">Edit Project</a>
        </div>
        <div v-else class="project-title__editor">
          <input ref="projectNameInput" v-model="projectName" class="headingOne pageIntro__heading project-title__input">
          <div>
            <a class="project-title__button" href="#!" @click.prevent="saveProjectTitle">Save Project</a>
            <a class="project-title__button" href="#!" @click.prevent="disableEditing">Cancel</a>
          </div>
        </div>
      </div>

      <div class="project-book-postcode">
        <div v-if="!editingPostcode">
          <h2 class="project-book-postcode__label">Postcode</h2>
          <p class="project-book-postcode__field">{{ userPostcode }}</p>
          <p class="paragraph"><a class="project-book-postcode__button" href="#!" @click.prevent="enableEditingPostcode">Edit</a></p>
        </div>
        <div v-else class="project-title__editor">
          <h2 class="project-book-postcode__label">Postcode</h2>
          <input ref="postcodeInput" v-model="userPostcode" class="project-book-postcode__field project-title__input">
          <div>
            <a class="project-book-postcode__button" href="#!" @click.prevent="savePostcode">Save postcode</a>
            <a class="project-book-postcode__button" href="#!" @click.prevent="disableEditingPostcode">Cancel</a>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="project">
        <div class="project__columnNames project__columns">
          <p class="project__column paragraph">Product</p>
          <p class="project__column paragraph">Qty</p>
          <p class="project__column paragraph">Price</p>
          <p class="project__column paragraph">Notes</p>
        </div>

        <project-book-item v-for="(item, index) in projectItems" :key="item.id" :item="item" @remove="removeProjectItem(index)" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../config/axios';

export default {
	props: {
		id: { 
			type: Number, 
			default: null 
		},
		name: { 
			type: String, 
			default: ''
		},
		items: {
			type: Array, 
			default: null
		},
		postcode: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			projectId: this.id,
			projectName: this.name,
			editing: false,
			editingPostcode: false,
			userPostcode: this.postcode,
			projectItems: this.items
		};
	},
	methods: {
		enableEditing() {
			this.editing = true;
			this.$nextTick(() => this.$refs.projectNameInput.focus());
		},
		disableEditing() {
			this.editing = false;
		},
		saveProjectTitle() {
			const data = {
				id: this.projectId,
				name: this.projectName
			};

			axios.post('/actions/projectbook/projects/update', data)
			.then(() => { this.editing = false; });
		},
		enableEditingPostcode() {
			this.editingPostcode = true;
			this.$nextTick(() => this.$refs.postcodeInput.focus());
		},
		disableEditingPostcode() {
			this.editingPostcode = false;
		},
		savePostcode() {
			const data = {
				postcode: this.userPostcode
			};

			axios.post('/actions/projectbook/postcode/update', data)
			.then(() => { 
				this.editingPostcode = false; 
				if(this.userPostcode !== '') {
					this.$parent.$refs.stockistSearchLink.href = '/stockists?postcode=' + encodeURIComponent(this.userPostcode);
				}
				
			});
		},
		removeProjectItem(index) {
			const projectItem = this.projectItems[index];

			const data = {
				id: projectItem.id
			};

			axios.post('/actions/projectbook/project-item/remove',data)
			.then(() => {
				this.projectItems.splice(index, 1);
			});
		}
	}
};
</script>
